<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="container border rounded" style="background-color:powderblue;">
      <div class="row justify-content-md-center">
        <span *ngIf="Item.ID != -1">{{Item.Naziv + ", " + mestoNaziv}}</span>
        <span *ngIf="Item.ID == -1" translate="FIRMA.NEW.SINGULAR"></span>
      </div>
    </div>
    <div class="row tabs-cont" #tabsCont>
      <div class="col-md-12 h-100">
        <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
          <ngb-tab title="{{'FIRMA.BASIC'|translate}}" id="tbList">
            <ng-template ngbTabContent>
              <div class="form-group row">
                <!-- <label class="col-form-label col-3"><span translate="COMPANY.NAZIV.SINGULAR"></span></label> -->
                <div class="col-md-12">
                  <yt-input [Type]="'text'" name="txtNaziv" formControlName="Naziv" #autofocus [MaxLength]="200"
                            [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}" [Label]="'FIRMA.NAZIV.SINGULAR'">
                  </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- <label class="col-form-label col-3"><span translate="COMPANY.NAZIV.SINGULAR"></span></label> -->
                <div class="col-md-12">
                  <yt-input [Type]="'text'" name="txtSNaziv" formControlName="SNaziv" #autofocus [MaxLength]="100"
                            [ngClass]="{'is-invalid': submitted && fc.SNaziv.invalid}" [Label]="'FIRMA.SNAZIV.SINGULAR'">
                  </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.SNaziv.invalid">
                    <span *ngFor="let validation of errorMessages.SNaziv">
                      <span class="error-message" *ngIf="fc.SNaziv.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.VRSTAKOMITENTAID.SINGULAR"></span></label> -->
                <div class="col-md-6">
                  <yt-dropdown-picklist [ModelName]="'tipkomitenta'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                                        formControlName="TipKomitentaID" [Label]="'FIRMA.TIPKOMITENTA.SINGULAR'" [Position]="'left'"
                                        [AllowAddNew]="false" (OnItemSelected)="onTipKomitentaSelect($event)">
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                    <span class="error-message"
                          *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid">
                      <span translate="{{this.baseFormGroup.errors.checkControls.message}}"></span>
                    </span>
                  </div>
                  <div class="form-error" *ngIf="submitted && fc.TipKomitentaID.invalid">
                    <span *ngFor="let validation of errorMessages.TipKomitentaID">
                      <span class="error-message" *ngIf="fc.TipKomitentaID.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group row">
    <div class="col-md-6">
      <yt-input
        [Type]="'text'"
        name="txtPib"
        formControlName="Pib"
        [MaxLength]="9"
        [ngClass]="{'is-invalid': submitted && fc.Pib.invalid}"
        [Label]="'FIRMA.PIB.SINGULAR'">
      </yt-input>
        <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
            <span *ngFor="let validation of errorMessages.Pib">
              <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
    </div>
    <div class="col-md-6">
        <yt-input
          [Type]="'text'"
          name="txtMaticniBroj"
          formControlName="MaticniBroj"
          [MaxLength]="30"
          [ngClass]="{'is-invalid': submitted && fc.MaticniBroj.invalid}"
          [Label]="'FIRMA.MATICNIBROJ.SINGULAR'">
        </yt-input>
          <div class="form-error" *ngIf="submitted && fc.MaticniBroj.invalid">
              <span *ngFor="let validation of errorMessages.MaticniBroj">
                <span class="error-message" *ngIf="fc.MaticniBroj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
          </div>
      </div>
  </div> -->
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-10 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtPib" formControlName="Pib" [MaxLength]="9"
                                [ngClass]="{'is-invalid': submitted && fc.Pib.invalid}" [Label]="'FIRMA.PIB.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
                        <span *ngFor="let validation of errorMessages.Pib">
                          <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
              <span class="input-group-append">
                  <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.PIB.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByPib()" ><span class="fa fa-fw fa-download"></span></button>
              </span>
          </div> -->
                    <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end"
                         [hidden]="this.Item.ID > -1">
                      <span class="input-group-append">
                        <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.PIB.TOOLTIP' | translate }}"
                                placement="top" container="body" (click)="GetCompanyDataByPibNovo()"
                                [disabled]="loadingCompanyDataByPib">
                          <span *ngIf="!loadingCompanyDataByPib" class="fas fa-fw fa-cloud-download-alt"></span>
                          <span *ngIf="loadingCompanyDataByPib" class="loader">
                            <span class="fa fa-spinner fa-spin"></span>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-10 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtMatbr" formControlName="MaticniBroj" [MaxLength]="8"
                                [ngClass]="{'is-invalid': submitted && fc.MaticniBroj.invalid}"
                                [Label]="'FIRMA.MATICNIBROJ.SINGULAR'"
                                [addLeadingZeros]="8">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.MaticniBroj.invalid">
                        <span *ngFor="let validation of errorMessages.MaticniBroj">
                          <span class="error-message" *ngIf="fc.MaticniBroj.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
              <span class="input-group-append">
                  <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.MATICNIBROJ.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByMatBr()" ><span class="fa fa-fw fa-download"></span></button>
              </span>
          </div>  -->
                    <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end"
                         [hidden]="this.Item.ID > -1">
                      <span class="input-group-append">
                        <button type="button" class="btn btn-secondary"
                                ngbTooltip="{{'NBS.MATICNIBROJ.TOOLTIP' | translate }}" placement="top" container="body"
                                (click)="GetCompanyDataByMatBrNovo()" [disabled]="loadingCompanyDataByMB">
                          <span *ngIf="!loadingCompanyDataByMB" class="fas fa-fw fa-cloud-download-alt"></span>
                          <span *ngIf="loadingCompanyDataByMB" class="loader">
                            <span class="fa fa-spinner fa-spin"></span>
                          </span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input [Type]="'text'" name="txtJbkjs" formControlName="Jbkjs" [MaxLength]="5"
                                [ngClass]="{'is-invalid': submitted && fc.Jbkjs.invalid}" [Label]="'FIRMA.JBKJS.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Jbkjs.invalid">
                        <span *ngFor="let validation of errorMessages.Jbkjs">
                          <span class="error-message" *ngIf="fc.Jbkjs.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.PIB.SINGULAR"></span></label> -->
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtJmbg" formControlName="Jmbg" [MaxLength]="13"
                                [ngClass]="{'is-invalid': submitted && fc.Jmbg.invalid}" [Label]="'FIRMA.JMBG.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="(fc.Jmbg.invalid && fc.Jmbg.dirty) || (fc.Jmbg.invalid && submitted)">
                        <span *ngFor="let validation of errorMessages.Jmbg">
                          <span class="error-message" *ngIf="fc.Jmbg.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtBrojGazdinstva" formControlName="BrojGazdinstva"
                                [MaxLength]="30" [ngClass]="{'is-invalid': submitted && fc.BrojGazdinstva.invalid}"
                                [Label]="'FIRMA.BROJGAZDINSTVA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.BrojGazdinstva.invalid">
                        <span *ngFor="let validation of errorMessages.BrojGazdinstva">
                          <span class="error-message" *ngIf="fc.BrojGazdinstva.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-2">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="PdvUSistemu"
                               id="chkUPdvSistemu">
                        <label class="form-check-label" for="chkUPdvSistemu">
                          <span translate="FIRMA.PDVUSISTEMU.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtGln" formControlName="Gln"
                                [Label]="'FIRMA.GLN.SINGULAR'"
                                [MaxLength]="13" ngbTooltip="{{'FIRMA.GLN.TOOLTIP' | translate }}">
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtPdvBroj" formControlName="PdvBroj"
                                [Label]="'FIRMA.PDVBROJ.SINGULAR'">
                        [MaxLength]="15"
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12 col-12">
                      <yt-dropdown-picklist [ModelName]="'poreskooslobodjenje'" [GetName]="'get'"
                                            [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'" [AllowAddNew]="false"
                                            formControlName="PoreskoOslobodjenjeID" [Label]="'FIRMA.PORESKOOSLOBODJENJE.SINGULAR'"
                                            [Width]="'xl'" [Position]="'right'" [Required]="false">
                      </yt-dropdown-picklist>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-3"><span translate="COMPANY.ADRESA.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtAdresa" formControlName="Adresa" [MaxLength]="200"
                                [ngClass]="{'is-invalid': submitted && fc.Adresa.invalid}" [Label]="'FIRMA.ADRESA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
                        <span *ngFor="let validation of errorMessages.Adresa">
                          <span class="error-message" *ngIf="fc.Adresa.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-3"><span translate="COMPANY.MESTO.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <!-- <yt-dropdown-picklist
            [ModelName]="'mesto'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]="true"
            formControlName="MestoID"
            [Label]="'COMPANY.MESTO.SINGULAR'"
            >
            </yt-dropdown-picklist>  -->

                      <yt-autocomplete [ModelName]="'mesto'" [GetName]="'getByNaziv'" [ModelProperty]="'Naziv'"
                                       [OrderBy]="'Naziv'" [AllowAddNew]="true" [Label]="'FIRMA.MESTO.SINGULAR'"
                                       formControlName="MestoID" (OnItemSelected)="onMestoSelected($event)">
                      </yt-autocomplete>

                      <!-- <yt-fw-dropdown
            [ModelName]="'mesto'"
            [GetName]="'get'"
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]='false'
            [Disabled]='false'
            [Required]='true'
            formControlName="MestoID"
            name="cmbMesto"
            [Type]="ID"
            [ngClass]="{'is-invalid': submitted && fc.MestoID.invalid}"
            [Label]="'COMPANY.MESTO.SINGULAR'">
          </yt-fw-dropdown> -->
                      <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
                        <span *ngFor="let validation of errorMessages.MestoID">
                          <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <!-- <div class="form-group row">
    <div class="col-md-12">
      <yt-autocomplete
        [ModelName]="'mesto'"
        [GetName]="'getByNaziv'"
        [ModelProperty]="'Naziv'"
        [OrderBy]="'Naziv'"
        [AllowAddNew]="false"
        formControlName="MestoID"
        [Label]="'COMPANY.MESTO.SINGULAR'">
      </yt-autocomplete>
    </div>
  </div> -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-3"><span translate="COMPANY.ODGLICE.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-dropdown-picklist
                                            [ModelName]="'osoba'"
                                            [GetName]="'GetByOrgJedId'"
                                            [GetParameters]="parameterList"
                                            [ModelProperty]="'Prezime,Ime,Jmbg'"
                                            [OrderBy]="'Prezime'"
                                            [AllowAddNew]="true"
                                            formControlName="OdgovornoLiceID"
                                            [Required]="false"
                                            [Label]="'FIRMA.ODGLICE.SINGULAR'"
                                            [Width]="'800px'"
                                            [Position]="'left'">
                      </yt-dropdown-picklist>
                      <!-- <yt-input
            [Type]="'text'"
            name="txtOdgLice"
            formControlName="OdgLice"
            [MaxLength]="100"
            [Label]="'FIRMA.ODGLICE.SINGULAR'">
          </yt-input> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-3"><span translate="COMPANY.REGISTARSKIBROJ.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtRegBr" formControlName="RegistarskiBroj" [MaxLength]="30"
                                [Label]="'FIRMA.REGISTARSKIBROJ.SINGULAR'">
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtSifraDelatnosti" formControlName="SifraDelatnosti"
                                [MaxLength]="30" [Label]="'FIRMA.SIFRADELATNOSTI.SINGULAR'">
                      </yt-input>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group row">
    <div class="col-md-12">
      <yt-input
        [Type]="'text'"
        name="txtSifraDelatnosti"
        formControlName="SifraDelatnosti"
        [MaxLength]="30"
        [Label]="'COMPANY.SIFRADELATNOSTI.SINGULAR'">
      </yt-input>
    </div>
  </div> -->

              <div class="form-group row">
                <!-- <label class="col-form-label col-3"><span translate="COMPANY.WEB.SINGULAR"></span></label> -->
                <div class="col-md-4">
                  <yt-input [Type]="'text'" name="txtWeb" formControlName="Web" [MaxLength]="50"
                            [Label]="'FIRMA.WEB.SINGULAR'">
                  </yt-input>
                </div>
                <div class="col-md-4">
                  <!-- <yt-fw-dropdown
          [ModelName]="'language'"
          [GetName]="'get'"
          [ModelProperty]="'Name'"
          [OrderBy]="'Name'"
          [AllowAddNew]='false'
          [Disabled]='false'
          [Required]='true'
          formControlName="LanguageID"
          name="cmbLanguage"
          [Type]="ID"
          [ngClass]="{'is-invalid': submitted && fc.LanguageID.invalid}"
          [Label]="'COMPANY.LANGUAGE.SINGULAR'">
        </yt-fw-dropdown> -->
                  <yt-dropdown-picklist [ModelName]="'language'" [GetName]="'get'" [ModelProperty]="'Name'"
                                        [OrderBy]="'Name'" [AllowAddNew]="false" formControlName="LanguageID"
                                        [Label]="'FIRMA.LANGUAGE.SINGULAR'">
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.LanguageID.invalid">
                    <span *ngFor="let validation of errorMessages.LanguageID">
                      <span class="error-message" *ngIf="fc.LanguageID.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-4 col-6">
                  <div class="form-group row">
                    <div class="col-md-12 col-12">
                      <yt-dropdown-picklist
                                            [ModelName]="'valuta'"
                                            [GetName]="'get'"
                                            [ModelProperty]="'Naziv,Sifra,ISOAlpha3Code'"
                                            [OrderBy]="'Naziv'"
                                            [AllowAddNew]="false"
                                            formControlName="ValutaID"
                                            [Label]="'FIRMA.VALUTA.SINGULAR'"
                                            [Width]="'l'"
                                            [Position]="'left'"
                                            [FilterByAllColumns]="false"
                                            >
                      </yt-dropdown-picklist>
                      <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
                        <span *ngFor="let validation of errorMessages.ValutaID">
                          <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)">
                            <span translate="{{validation.message}}"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12">
                  <yt-text-area [MaxLength]="500" name="txtNapomena" formControlName="Napomena"
                                [Label]="'FIRMA.NAPOMENA.SINGULAR'">
                  </yt-text-area>
                </div>
                <!-- <label class="col-form-label col-3"><span translate="COMPANY.NAPOMENA.SINGULAR"></span></label>
      <div class="col-md-9">
        <textarea
          type="text"
          name="txtNapomena"
          class="form-control"
          formControlName="Napomena"
          maxlength="2000"
          autocomplete="off">
      </textarea>
      </div> -->
              </div>
              <span style="color:#25749b;">Logo</span>
              <br>
              <div class="form-group row">
                <div class="col-md-3">
                  <yt-upload [ModelName]="'firma'" formControlName="LogoUrl" [PostName]="'uploadImage'" [UploadType]="0"
                             [SupportedImageType]="['image/jpeg']">
                  </yt-upload>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <div class="btn-group float-right">
                    <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                    <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()" [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'FIRMAEMAIL.PLURAL'| translate}}" id="tbEmail">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[0]"
                    [ParentPropertyName]="'FirmaID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'FIRMATELEFON.PLURAL'| translate}}" id="tbTelefon">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[1]"
                    [ParentPropertyName]="'FirmaID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'FIRMAZRC.PLURAL'| translate}}" id="tbZrc">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <!-- <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[2]"
                    [ParentPropertyName]="'FirmaID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal> -->
                    <yt-company-zrc-new-tabs 
                    [Model]="'firma-zrc'"
                    [ParentPropertyName]="'FirmaID'" 
                    [ParentPropertyValue]="Item.ID"
                    ></yt-company-zrc-new-tabs>
                    <!-- [ParametersZrc]="Item.ID" -->
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</form>
